import { combineLatest, Observable, of } from "rxjs";
import { filter, mergeMap, debounceTime } from "rxjs/operators";
import { MapDimensionHookItem } from "../hooks/useMapDimension";
import { MapDataSourceId } from "../models/MapDataSource";
import { MapDimension } from "../models/MapDimension";
import { MapStore } from "../store";

export function attributesFilter$(store: MapStore): Observable<Record<string, unknown>> {
  const { dataSourceId$, dimensions$, dimensionsValues } = store;
  return combineLatest([dataSourceId$, dimensions$]).pipe(
    filter(([dataSourceId, dimensions]) => dimensions.every(e => e.dataSource?.id === dataSourceId)),
    mergeMap(([dataSourceId, dimensions]) => {
      const values = dimensions.map(dim => {
        const value$ = dimensionsValues.get(dim.id)!;
        return value$;
      });
      return combineLatest([of(dataSourceId), of(dimensions), ...values]);
    }),
    filter(([, , ...values]) => values.every(Boolean)),
    debounceTime(100),
    mergeMap(([dataSourceId, dimensions, ...values]) => {
      const parameters = {};
      (dimensions as MapDimension[]).forEach((dim, i) => {
        if (dim.hierarchy.includes('commodities')) {
          parameters['commodity_id'] = values[i];
        }
        if (dataSourceId === MapDataSourceId.UNComtrade && dim.hierarchy.includes('reporting_countries')) {
          parameters['reporter_id'] = values[i];
        }
      });
      return of(parameters);
    }),
  );
}
